import { render, staticRenderFns } from "./wonRate.vue?vue&type=template&id=483bff1c"
import script from "./wonRate.vue?vue&type=script&lang=js"
export * from "./wonRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports